import SitecoreTextModel from '@models/SitecoreTextModel';

export default class ContactInformationModel {
  constructor() {
    this.Title = new SitecoreTextModel();

    this['Change Text'] = new SitecoreTextModel();

    this['Save Change Text'] = new SitecoreTextModel();

    this['Phone Number Label'] = new SitecoreTextModel();

    this['Last Name Label'] = new SitecoreTextModel();

    this['First Name Label'] = new SitecoreTextModel();

    this['DoB Label'] = new SitecoreTextModel();

    this['OTP Input Text'] = new SitecoreTextModel();

    this['OTP Input'] = new SitecoreTextModel();

    this['Get OTP Label'] = new SitecoreTextModel();

    this['Resend Text'] = new SitecoreTextModel();

    this['OTP Sent Message'] = new SitecoreTextModel();
  }

  getData(dataSource) {
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Change Text')) {
      this['Change Text'].getData(dataSource['Change Text']);
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Title')) {
      this.Title.getData(dataSource.Title);
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Phone Number Label')) {
      this['Phone Number Label'].getData(dataSource['Phone Number Label']);
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Save Change Text')) {
      this['Save Change Text'].getData(dataSource['Save Change Text']);
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Last Name Label')) {
      this['Last Name Label'] = dataSource['Last Name Label'];
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'First Name Label')) {
      this['First Name Label'] = dataSource['First Name Label'];
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'DoB Label')) {
      this['DoB Label'].getData(dataSource['DoB Label']);
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'OTP Input Text')) {
      this['OTP Input Text'].getData(dataSource['OTP Input Text']);
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'OTP Input Text')) {
      this['OTP Input'].getData(dataSource['OTP Input Text']);
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Get OTP Label')) {
      this['Get OTP Label'].getData(dataSource['Get OTP Label']);
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Resend Text')) {
      this['Resend Text'].getData(dataSource['Resend Text']);
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'OTP Sent Message')) {
      this['OTP Sent Message'].getData(dataSource['OTP Sent Message']);
    }

    return this;
  }
}
